module.exports = __webpack_public_path__ + "img/DSC_0100.c1ef9fd0.jpg";